import React from "react";
import { useTranslation } from "react-i18next";
import { formInputStyles } from "../../../shared/constants/styles";
import {
  ActionIconContainer,
  AddFormButton,
} from "../../../shared/components/TableElements";
import { Container, Modal, Row, Col } from "react-bootstrap";
import {
  FormGroupLabel,
  FormItem,
} from "../../../shared/components/form/FormElements";
import Error from "../../../shared/components/form/Error";

const CreateWarehouseLocationPopup = ({
  show,
  onClose,
  onAddWarehouseLocation,
  warehouseLocationPopupErr,
}) => {
  const { t } = useTranslation("common");
  const [warehouseLocation, setWarehouseLocation] = React.useState("");
  // const inputRef = React.useRef(null);

  // React.useEffect(() => {
  //   if (show && inputRef.current) {
  //     // Small delay to ensure modal is fully rendered
  //     setTimeout(() => {
  //       inputRef.current?.focus();
  //     }, 100);
  //   }
  // }, [show]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && warehouseLocation.trim()) {
      onAddWarehouseLocation(warehouseLocation);
    }
  };

  return (
    <Modal show={show} size="md" centered backdropClassName="custom-backdrop">
      <Modal.Header>
        <h4>{t("add_warehouse_location")}</h4>
        <div className="d-flex justify-content-end">
          <ActionIconContainer onClick={onClose}>
            <i className="fi fi-rr-cross-small" />
          </ActionIconContainer>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Row className="mb-2">
            <Col md={12}>
                <FormGroupLabel className="m-0">{t("warehouse_loc")}</FormGroupLabel>
              <FormItem disabled={false}>
                <input
                  //ref={inputRef}
                  type="text"
                  name="warehouseLocation"
                  value={warehouseLocation}
                  onChange={(e) => setWarehouseLocation(e.target.value)}
                  onKeyDown={handleKeyDown}
                  //defaultValue=""
                  placeholder={t("warehouse_loc")}
                  style={formInputStyles}
                  disabled={false}
                />
              </FormItem>
              {warehouseLocationPopupErr && <Error error={warehouseLocationPopupErr} />}
            </Col>
          </Row>
        </Container>
      </Modal.Body>

      <Modal.Footer>
        <AddFormButton
          id="save-form-button"
          type="button"
          onClick={() => onAddWarehouseLocation(warehouseLocation)}
          disabled={!warehouseLocation.trim()}
        >
          {t("save")}
        </AddFormButton>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateWarehouseLocationPopup;
